import axios from "axios";

const apiV2 = axios.create({
  baseURL: process.env.VUE_APP_API_URL
});

// Request interceptor: attach auth token
apiV2.interceptors.request.use(
  function(config) {
    const token = localStorage.getItem("ctoken") || sessionStorage.getItem("ctoken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

// Response interceptor: basic error handling
apiV2.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);

export default apiV2;
